import { render, staticRenderFns } from "./OrbitSpinner.vue?vue&type=template&id=325a6afe&scoped=true&"
import script from "./OrbitSpinner.vue?vue&type=script&lang=js&"
export * from "./OrbitSpinner.vue?vue&type=script&lang=js&"
import style0 from "./OrbitSpinner.vue?vue&type=style&index=0&id=325a6afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325a6afe",
  null
  
)

export default component.exports